import Icon from '../components/Icon.vue'

Icon.register({
  'gas-pump': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M336 448H16C7.2 448 0 455.2 0 464V496C0 504.8 7.2 512 16 512H336C344.8 512 352 504.8 352 496V464C352 455.2 344.8 448 336 448zM493.2 107.3L412.2 26.3C406 20.1 395.8 20.1 389.6 26.3L378.3 37.6C372.1 43.8 372.1 54 378.3 60.2L416 97.9V160C416 188.1 436.9 211.3 464 215.2V376C464 389.2 453.2 400 440 400S416 389.2 416 376V344C416 295.4 376.6 256 328 256H320V64C320 28.7 291.3 0 256 0H96C60.7 0 32 28.7 32 64V416H320V304H328C350.1 304 368 321.9 368 344V371.8C368 409.5 395 443.8 432.5 447.7 475.5 452 512 418.2 512 376V152.6C512 135.6 505.2 119.3 493.2 107.3zM256 192H96V64H256V192z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/gas-pump.js
// module id = 0J4L
// module chunks = 144